import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	type ISSUE_RESTRICTION_GQL_FIELD,
	ISSUE_RESTRICTION_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';
import { getSystemAggJiraProject } from './project-field-transformer.tsx';

export type Restriction = {
	restrictionValue: string;
};

const transformJiraRoleToRestriction = (role: {
	readonly id: string;
	readonly roleId: string;
}): Restriction | null => {
	if (role == null) return null;
	return { restrictionValue: role.roleId };
};

export const transformAggIssueRestrictionToLegacyField: AggTransformerFunction<
	typeof ISSUE_RESTRICTION_GQL_FIELD
> = (node, context, projectContext) => {
	if (node.type !== ISSUE_RESTRICTION_TYPE) return undefined;

	const roles = transformAggConnection(
		node.selectedRolesConnection,
		transformJiraRoleToRestriction,
	);

	const restrictions = roles.length > 0 ? { projectrole: roles } : {};

	const project = fg('issue_view_move_isaienable_from_project_field')
		? projectContext
		: getSystemAggJiraProject(context);

	return {
		...transformAggNodeToLegacyField(node),
		value: {
			shouldDisplay: project?.canSetIssueRestriction === true,
			issuerestrictions: restrictions,
		},
		schema: {
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
			type: ISSUE_RESTRICTION_TYPE,
			custom: null,
			system: node.type,
		},
	};
};
